const dialog = document.querySelector('.js-cookies-popup');

if (dialog) {
	if (localStorage.getItem('cookieAccept') !== 'Y') {
		dialog.removeAttribute('hidden');

		dialog.querySelector('button').addEventListener('click', () => {
			localStorage.setItem('cookieAccept', 'Y');
			dialog.setAttribute('hidden', 'hidden');
		});
	}
}
